<app-referrals-standard-listing
  [loadingReferrals]="loadingReferrals"
  [eligibleReferrals]="eligibleReferrals"
  [ineligibleReferrals]="ineligibleReferrals"
  [referralMatchOptions]="editReferralMatchOptions"
  [showIneligibleReferrals]="showIneligibleReferrals"
  (referralVerificationChange)="onReferralVerificationChange($event)" />
